/**
 * ============================================================================
 * FEATURE FLAG: Google Calendar OAuth Connect V1 (ab-google-calendar)
 * PR: #2756
 *
 * Banner displayed above the topbar when the agent has not yet connected
 * their Google Calendar. Temporary code — will be REMOVED or PROMOTED when
 * the flag is fully rolled out.
 *
 * Find all flag-gated code: grep -r "ab-google-calendar" src/
 * ============================================================================
 */
import { Box, Button, paletteColors } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

import { useExperimentVariation } from '../../analytics/amplitude-hooks';
import { buildGoogleOAuthUrl } from '../../../resources/calendarConfig/operations';
import { useGetCalendarStatus } from '../../../resources/calendarConfig/queries';

export const CalendarConnectBanner = (): JSX.Element | null => {
    const { formatMessage } = useIntl();
    const variant = useExperimentVariation('ab-google-calendar');
    const showFeature = variant?.value === 'on' || variant?.value === 'treatment';
    const { data: calendarStatus, isLoading } = useGetCalendarStatus();

    if (!showFeature || isLoading || calendarStatus?.google === 'connected') {
        return null;
    }

    const handleConnect = () => {
        window.location.assign(buildGoogleOAuthUrl());
    };

    return (
        <Box
            data-spec-id="calendar-connect-banner"
            sx={{
                backgroundColor: paletteColors.blue[800],
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                px: 2,
                py: 0.5,
            }}
        >
            <Button
                data-spec-id="calendar-banner-connect-button"
                size="small"
                variant="contained"
                onClick={handleConnect}
                sx={{
                    backgroundColor: paletteColors.neutral[0],
                    color: paletteColors.blue[800],
                    '&:hover': {
                        backgroundColor: paletteColors.neutral[0],
                    },
                }}
            >
                {formatMessage({ id: 'calendar.connect.button' })}
            </Button>
        </Box>
    );
};
